export const getContent = (name: string) => {
  return `
      <div class="landmark-overlay">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#F5F1FF"/>
          <rect width="20" height="20" rx="10" fill="white"/>
          <path d="M5.44434 5H15.6665L13.111 8.83333L15.6665 12.6667H6.72211V17.7778H5.44434V5Z" fill="#2375F6"/>
        </svg>
        ${name}
      </div>
    `
}
